import { Deserializable } from './deserializable.model';

export class Timeline implements Deserializable {
  id = '';
  ano = 1970;
  acontecimento = '';
  ativo = false;

  deserialize(input: any) {
    Object.assign(this, input);
    return this;
  }
}
